module.exports = __webpack_public_path__ + "static/media/couple-stone-active.7bc8eb81.svg";